import React from 'react';
import Section from '../components/ui/Section';

const Cookie = () => {
  return (
    <div className="pt-24 min-h-screen">
      <Section className="pb-12 md:pb-24">
        <h1 className="text-4xl md:text-6xl mb-12">Cookie-Richtlinien</h1>
        
        <div className="max-w-3xl font-inter text-brand-text/80 space-y-8">
          <div>
            <h3 className="text-2xl text-brand-text mb-4 font-medium">Was sind Cookies?</h3>
            <p className="leading-relaxed mb-4">
              Cookies sind kleine Textdateien, die auf Ihrem Endgerät (Computer, Tablet, Smartphone) gespeichert werden, wenn Sie unsere Website besuchen. Sie dienen dazu, die Nutzung unserer Website für Sie angenehmer zu gestalten und bestimmte Funktionen zu ermöglichen.
            </p>
          </div>

          <div>
            <h3 className="text-2xl text-brand-text mb-4 font-medium">Welche Cookies verwenden wir?</h3>
            <p className="leading-relaxed mb-4">
              <strong>Notwendige Cookies:</strong><br/>
              Diese Cookies sind für das reibungslose Funktionieren der Website zwingend erforderlich. Sie ermöglichen grundlegende Funktionen wie die Seitennavigation und den Zugriff auf sichere Bereiche der Website.
            </p>
            <p className="leading-relaxed mb-4">
              <strong>Analyse-Cookies (optional):</strong><br/>
              Wir verwenden anonymisierte Analyse-Tools, um zu verstehen, wie Besucher mit unserer Website interagieren. Diese Informationen helfen uns, unsere Website und Ihr Nutzungserlebnis kontinuierlich zu verbessern.
            </p>
          </div>

          <div>
            <h3 className="text-2xl text-brand-text mb-4 font-medium">Ihre Kontrolle über Cookies</h3>
            <p className="leading-relaxed mb-4">
              Sie können die Speicherung von Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen können.
            </p>
            <p className="leading-relaxed">
              Darüber hinaus können Sie bereits gespeicherte Cookies jederzeit über Ihren Browser löschen.
            </p>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Cookie;